/*
Copyright 2026 Element Creations Ltd.

SPDX-License-Identifier: AGPL-3.0-only OR LicenseRef-Element-Commercial
Please see LICENSE in the repository root for full details.
*/

/** Still image shipped with this widget. Same file for every clinic. */
export const bundledCallBackgroundPath = "/VIBS9-background.jpg";

/**
 * Clinic image when the host passed one, otherwise the image shipped with
 * the widget.
 */
export function callBackgroundImagePath(supplied: string | undefined): string {
  return supplied ?? bundledCallBackgroundPath;
}

/**
 * A scheme means the image is served by another host. The widget's own file
 * is a root-relative path and must be loaded without a CORS mode, because
 * this server does not send Access-Control-Allow-Origin for it.
 */
export function backgroundImageUsesAnonymousCors(path: string): boolean {
  return /^[a-z][a-z0-9+.-]*:/i.test(path);
}
